/**
 * Normalisiert eine URL fuer den Self-Match in `handleNoIndexCase()`
 * (RouteContextService): Query + Hash weg, Trailing Slash weg (ausser der
 * Pfad ist nur `/`).
 *
 * Hintergrund: Der fruehere `===`-Vergleich gegen `window.location.href` ging
 * nur auf, weil Firebase Hosting `/en/poll-templates/` vor dem Angular-Boot
 * auf die slash-lose Form 301-redirected. Die Normalisierung macht den
 * Vergleich unabhaengig von dieser versteckten Kopplung (Audit
 * sample-poll-server-rendering-2026-08-03, Befund 3).
 */
export function normalizeUrlForIndexCheck(url: string): string {
    let normalized = url.split('#')[0].split('?')[0];
    if (normalized.endsWith('/')) {
        try {
            if (new URL(normalized).pathname !== '/') {
                normalized = normalized.slice(0, -1);
            }
        } catch {
            // relative/kaputte URL: Slash strippen, solange mehr als "/" uebrig bleibt
            if (normalized.length > 1) {
                normalized = normalized.slice(0, -1);
            }
        }
    }
    return normalized;
}
